import { CommonModule } from '@angular/common'
import { Component, Inject } from '@angular/core'
import { CrispService } from '../../../../../core/services/crisp.service'
import { OneIconComponent } from '../../../one-icon/one-icon.component'
import { Shop } from '../shop-switch.model'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
    templateUrl: './reinstall-modal.component.html',
    styleUrls: ['./reinstall-modal.component.scss'],
    imports: [
        CommonModule,
        OneIconComponent,
    ]
})
export class ReinstallModalComponent {
  constructor(
    private crispService: CrispService,
    public dialogRef: MatDialogRef<ReinstallModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {shop: Shop},
  ) {
    this.dialogRef.addPanelClass(['_no-padding'])
  }

  onLiveChatClick(event) {
    event.preventDefault()
    const crisp = this.crispService.getCrisp()
    if (crisp) {
      crisp.push(['do', 'chat:open'])
      crisp.push(['do', 'message:send', ['text', `I am having trouble re-installing and / or switching to ${this.data?.shop?.shopify_store_subdomain} on my ONE account store switcher.`]])
    }
  }
}
